export default __webpack_public_path__ + "static/media/cb.5d957e52.png";